import { render, staticRenderFns } from "./AppSummaryViewHealthPlus.vue?vue&type=template&id=541a1980&scoped=true"
import script from "./AppSummaryViewHealthPlus.vue?vue&type=script&lang=js"
export * from "./AppSummaryViewHealthPlus.vue?vue&type=script&lang=js"
import style0 from "./AppSummaryViewHealthPlus.vue?vue&type=style&index=0&id=541a1980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541a1980",
  null
  
)

export default component.exports